export function sum(numbers) {
  // function for adding two numbers. Easy!
  const add = (a, b) => Number(a) + Number(b);
  // use reduce to sum our array
  return numbers === undefined ? 0 : numbers.reduce(add);
}
